import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

export default function Login() {
  const { login, loginConToken, API } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [tab, setTab] = useState(params.get('tab') === 'registro' ? 'registro' : 'login');
  const [form, setForm] = useState({
    // login
    email: '', password: '',
    // registro empresa
    empresa_nombre: '', empresa_nit: '',
    nombre: '', cedula: '', celular: '', cargo: '',
  });
  const [error, setError] = useState('');
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const handle = e => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = async e => {
    e.preventDefault();
    setError(''); setMsg(''); setLoading(true);
    try {
      if (tab === 'login') {
        await login(form.email, form.password);
        nav('/');
      } else {
        const r = await axios.post(`${API}/empresas/registro`, {
          empresa_nombre: form.empresa_nombre,
          empresa_nit: form.empresa_nit,
          nombre: form.nombre,
          email: form.email,
          password: form.password,
          cedula: form.cedula,
          celular: form.celular,
          cargo: form.cargo,
        });
        // Auto-login con el token devuelto y redirigir al pago
        await loginConToken({ ...r.data, email: form.email });
        nav('/suscripcion?nuevo=1');
        return;
      }
    } catch (err) {
      setError(err.response?.data?.detail || 'Error, intenta de nuevo');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logo}>🏦</div>
        <h1 style={styles.title}>ConciliaApp</h1>
        <p style={styles.sub}>Conciliación bancaria</p>

        <div style={styles.tabs}>
          {['login', 'registro'].map(t => (
            <button key={t}
              style={{ ...styles.tab, ...(tab === t ? styles.tabActive : {}) }}
              onClick={() => { setTab(t); setError(''); setMsg(''); }}>
              {t === 'login' ? 'Ingresar' : 'Nueva empresa'}
            </button>
          ))}
        </div>

        <form onSubmit={submit} style={styles.form}>
          {tab === 'registro' && (
            <>
              <p style={styles.hint}>Registra tu empresa y activa tu plan para comenzar.</p>
              <input style={styles.input} name="empresa_nombre" placeholder="Nombre de la empresa *" value={form.empresa_nombre} onChange={handle} required />
              <input style={styles.input} name="empresa_nit" placeholder="NIT de la empresa" value={form.empresa_nit} onChange={handle} />
              <div style={styles.divider} />
              <p style={styles.sectionLabel}>Datos del administrador</p>
              <input style={styles.input} name="nombre" placeholder="Nombre completo *" value={form.nombre} onChange={handle} required />
              <div style={styles.row}>
                <input style={styles.input} name="cedula" placeholder="Cédula *" value={form.cedula} onChange={handle} required />
                <input style={styles.input} name="celular" placeholder="Celular *" value={form.celular} onChange={handle} required />
              </div>
              <input style={styles.input} name="cargo" placeholder="Cargo" value={form.cargo} onChange={handle} />
            </>
          )}

          <input style={styles.input} name="email" type="email" placeholder="Correo electrónico *" value={form.email} onChange={handle} required />
          <input style={styles.input} name="password" type="password" placeholder="Contraseña *" value={form.password} onChange={handle} required />

          {tab === 'login' && (
            <a href="/olvide-password" style={styles.forgot}>¿Olvidaste tu contraseña?</a>
          )}

          {error && <p style={styles.error}>{error}</p>}
          {msg && <p style={styles.success}>{msg}</p>}

          <button style={styles.btn} disabled={loading}>
            {loading ? 'Cargando...' : tab === 'login' ? 'Ingresar' : 'Crear empresa y continuar'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f4f4f5' },
  card: { background: '#fff', borderRadius: 16, padding: '2.5rem 2rem', width: 420, boxShadow: '0 4px 24px rgba(0,0,0,0.08)' },
  logo: { fontSize: 40, textAlign: 'center', marginBottom: 8 },
  title: { textAlign: 'center', fontSize: 22, fontWeight: 600, margin: 0 },
  sub: { textAlign: 'center', color: '#666', fontSize: 14, marginBottom: 24, marginTop: 4 },
  forgot: { fontSize: 12, color: '#2563eb', textDecoration: 'none', alignSelf: 'flex-end', marginTop: -4 },
  tabs: { display: 'flex', background: '#f4f4f5', borderRadius: 10, padding: 4, marginBottom: 20 },
  tab: { flex: 1, padding: '8px 0', border: 'none', background: 'transparent', cursor: 'pointer', borderRadius: 8, fontSize: 14, color: '#555' },
  tabActive: { background: '#fff', fontWeight: 600, color: '#111', boxShadow: '0 1px 4px rgba(0,0,0,0.1)' },
  form: { display: 'flex', flexDirection: 'column', gap: 10 },
  hint: { fontSize: 13, color: '#2563eb', background: '#eff6ff', borderRadius: 8, padding: '8px 12px', margin: 0 },
  sectionLabel: { fontSize: 12, fontWeight: 600, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.05em', margin: '2px 0 0' },
  divider: { borderTop: '1px solid #e5e7eb', margin: '2px 0' },
  row: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 },
  input: { padding: '10px 14px', borderRadius: 8, border: '1px solid #e0e0e0', fontSize: 14, outline: 'none', width: '100%', boxSizing: 'border-box' },
  btn: { padding: '12px', borderRadius: 8, background: '#2563eb', color: '#fff', border: 'none', fontWeight: 600, fontSize: 15, cursor: 'pointer', marginTop: 4 },
  error: { color: '#dc2626', fontSize: 13, margin: 0 },
  success: { color: '#16a34a', fontSize: 13, margin: 0 },
};
